import React from "react";
import { Link } from "react-router-dom";

function ValueProps() {
  return (
    <section className="section value-props">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2>From Event to Insight — Secure, Scalable, Stream-Powered</h2>
          <p className="section-description">
            Our architecture ensures that every event — whether a transaction,
            login, or anomaly — becomes a live signal across your enterprise.
          </p>
        </div>

        <div className="value-grid">
          <div className="value-card" data-aos="fade-up" data-aos-delay="100">
            <div className="value-icon">
              <i className="fas fa-network-wired"></i>
            </div>
            <h3>Unified Data Plane</h3>
            <p>
              Single platform for all your real-time data needs across apps,
              analytics, and security.
            </p>
          </div>

          <div className="value-card" data-aos="fade-up" data-aos-delay="150">
            <div className="value-icon">
              <i className="fas fa-chart-pie"></i>
            </div>
            <h3>40% Cost Reduction</h3>
            <p>
              Significantly cut integration costs with our streamlined,
              efficient architecture.
            </p>
          </div>

          <div className="value-card" data-aos="fade-up" data-aos-delay="200">
            <div className="value-icon">
              <i className="fas fa-plug"></i>
            </div>
            <h3>Plug-and-Play</h3>
            <p>
              Pre-built connectors to any system for rapid deployment and
              integration.
            </p>
          </div>

          <div className="value-card" data-aos="fade-up" data-aos-delay="250">
            <div className="value-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Built-in Governance</h3>
            <p>
              Complete audit trail and governance controls for compliance and
              security.
            </p>
          </div>
        </div>

        <div className="cta-box" data-aos="fade-up">
          <h3>
            From Streams to Outcomes: Real-Time Use Cases that Deliver
            Measurable Value
          </h3>
          <p>Bringing Real-Time Intelligence to Every Decision.</p>
          <Link to="/login" 
            className="btn btn-primary"
            style={{ 
              cursor: 'pointer',
              pointerEvents: 'auto',
            }}
          >
            Discover How
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ValueProps;
